import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { rootTranslation } from 'utils/format';
import { CreateNewButton } from '../create/CreateNewButton';

const t = rootTranslation('drawers.productionSetup.tracks');

export function SearchEmptyState() {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          py: 3,
          mx: 'auto',
          width: '600px',
          textAlign: 'center',
          mt: 3,
        }}
      >
        <Typography variant="h4">{t('searchPlaceholder.heading')}</Typography>
        <Typography variant="body1" sx={{ textWrap: 'balance' }}>
          {t('searchPlaceholder.bodyPrimary')}
        </Typography>
        <div>
          <CreateNewButton />
        </div>
      </Box>
    </Box>
  );
}
